export const phoneCode = [
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
  }
];
